<template>
  <footer class="bg-primary p-4 mt-100">
    <div class="container">
      <div class="row">
        <div class="col-md-1 d-none d-md-block">
          <img src="/assets/images/1.png" style="width: 75%" class="img-fluid" />
        </div>
        <div class="col-md-5">
          <p class="footer-header">Dinas Pendidikan Provinsi Jawa Barat</p>
          <hr />
          <p class="footer-core-info">
            <b>Layanan Contact Center Disdik</b> <br />
            Call Center : 08001503001 <br />
            Formulir Pengaduan - Link <br />
            Live Chat - Link <br /><br />
            Jam operasional Contact Center : <br />
            Hari Senin - Minggu, Pukul 08.00 - 20.00 WIB
          </p>
          <hr />
          <p>
            <i class="lni lni-instagram"></i>
            &nbsp;
            <i class="lni lni-facebook-original"></i>
            &nbsp;
            <i class="lni lni-twitter-original"></i>
          </p>
        </div>
        <div class="col-md-4 ms-auto d-none d-md-block">
          <ul class="footer-link" style="list-style: none">
            <li>Beranda</li>
            <li class="mt-3">Tentang Kami</li>
            <li class="mt-3">Laporan Sekolah</li>
            <li class="mt-3">FAQ</li>
            <li class="mt-3">Hubungi Kami</li>
            <li class="mt-3">Masuk — Login</li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footers'
}
</script>
